import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'aa-input-upload',
    templateUrl: './input-upload.component.html',
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InputUploadComponent implements OnInit
{
    public invalid: boolean = true;
    constructor() { }

    ngOnInit ()
    {
    }
    onUploadError ($event)
    {
    }

    onUploadSuccess ($event)
    {
    }
}
